export default __webpack_public_path__ + "static/media/src_assets_main_logo.0355afa3.svg";